import { cx } from "shared/utils";

interface CreditScoreGraphProps {
  score: number;
  tooltipSize?: "S" | "L";
}

// 300-499: Poor
// 500-600: Fair
// 601-660: Good
// 661-780: Very Good
// 781-850: Excellent

const getColor = (score: number) => {
  if (score < 500) return "bg-danger-500";
  if (score < 601) return "bg-warning-500";
  if (score < 661) return "bg-success-500";
  if (score < 781) return "bg-success-700";
  return "bg-success-800";
};

export const CreditScoreGraph = ({
  score,
  tooltipSize = "L"
}: CreditScoreGraphProps) => {
  return (
    <>
      <div className="mb-2 mt-3 flex justify-between text-sm font-medium">
        {score ? (
          <>
            <p className="text-sm text-danger-500">300</p>
            <p className="text-sm text-success-700">850</p>
          </>
        ) : (
          <p className="text-sm text-content-100">No data yet</p>
        )}
      </div>

      {/* Tooltip */}
      {score && (
        <div className="relative">
          <div
            className={`absolute ${
              tooltipSize === "S" ? "top-[-40px]" : "top-[-50px]"
            } -translate-x-1/2`}
            style={{ left: `${(score - 300) / 5.5}%` }}
          >
            <div
              role="tooltip"
              className={`flex w-full items-center justify-center rounded-lg
              ${tooltipSize === "S" ? "h-8 px-2 py-1" : "h-10 px-3.5 py-2"}
              ${getColor(score)}`}
            >
              <p className="font-bold text-white">{score}</p>
              <div
                id="arrow"
                className={`
                ${tooltipSize === "S" ? "top-[28px]" : "top-[36px]"}
                invisible absolute h-2 w-2 bg-inherit before:visible before:absolute before:h-2 before:w-2 before:rotate-45 before:bg-inherit before:content-['']`}
                data-popper-arrow
              ></div>
            </div>
          </div>
        </div>
      )}

      {/* Scorebar */}
      <div className="mb-4 flex h-4 gap-0.5 overflow-hidden rounded-lg text-xs">
        <div
          style={{ width: `${(499 - 300) / 5.5}%` }}
          className={cx(score ? "bg-danger-500" : "bg-alpha-40")}
        ></div>
        <div
          style={{ width: `${(600 - 500) / 5.5}%` }}
          className={cx(score ? "bg-warning-500" : "bg-alpha-40")}
        ></div>
        <div
          style={{ width: `${(660 - 601) / 5.5}%` }}
          className={cx(score ? "bg-success-500" : "bg-alpha-40")}
        ></div>
        <div
          style={{ width: `${(780 - 661) / 5.5}%` }}
          className={cx(score ? "bg-success-700" : "bg-alpha-40")}
        ></div>
        <div
          style={{ width: `${(850 - 781) / 5.5}%` }}
          className={cx(score ? "bg-success-800" : "bg-alpha-40")}
        ></div>
      </div>
    </>
  );
};
